import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  fdeMorningStarNavObject,
} from "../../../../../common/it-interface";
import {convertToSnakeCase} from "../../../../../common/it-utils";
import {SIDE_NAV_TITLES} from "../../../../../common/it-constants";

@Component({
  selector: 'app-ms-nav-table',
  templateUrl: './ms-nav-table.component.html',
  styleUrls: ['./ms-nav-table.component.scss']
})
export class MsNavTableComponent implements OnInit {

  @Input() tableDataShow: string;
  @Input() listOfFdeMsNavByHstDate: fdeMorningStarNavObject[];

  fundDayEndReportKey = convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);

  constructor() { }

  ngOnInit() {
    this.listOfFdeMsNavByHstDate = [];
  }

}
